















import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import Pagination from 'vuejs-paginate'

@Component<Paginator>({
    components: {
        Pagination
    }
})
export default class Paginator extends Vue {
    @Prop({ type: Number, required: true })
    private maxItemsPerPage !: number  // Number of items to display each page
    @Prop({ type: Number, required: true })
    private listItemCount !: number    // Total number of items in list/table that is being paginated
    @Prop({ type: Number, required: true })
    private currentPageNumber !: number

    private get totalPageCount(): number {
        return Math.ceil(this.listItemCount / this.maxItemsPerPage)
    }

    private onChangePageNumber(pageNum) {
        this.$emit('pageChanged', pageNum)
    }
}
